import React, { useState } from "react";
import * as d3 from "d3";
import socioEconomic from "../../../../data/socioEconomic";
import socio from "../../../../data/socio";
import styles from "./NeighborhoodTable.module.css";
import moment from "moment";
import { StoreMallDirectorySharp } from "@material-ui/icons";

const today = moment().format("MM/DD/YYYY");
const this_day = moment().format("MMMM Do");

const parse_time = d3.timeParse("%m/%d/%Y");
const normalize = (d) =>
  d.toLowerCase().split(" ").join("").split("'").join("").split("/")[0];

const NeighborhoodTable = ({ data }) => {
  const [fullMode, setFullMode] = useState(false),
    neighborhoods = d3.rollup(
      data.filter((d) => {
        return (
          d3.timeFormat("%m/%d")(parse_time(d.dateofincident)) <=
          d3.timeFormat("%m/%d")(parse_time(today))
        );
      }),
      (v) => v.length,
      (d) => d.communityarea,
      (d) => d3.timeFormat("%Y")(parse_time(d.dateofincident))
    );

  const chicago_avg =
    d3.sum(neighborhoods, (d) => d[1].get("2021")) /
    d3.sum(neighborhoods, (d) => 1);

  const chicago_2020_avg =
    d3.sum(neighborhoods, (d) => d[1].get("2020")) /
    d3.sum(neighborhoods, (d) => 1);

  const chicago_2019_avg =
    d3.sum(neighborhoods, (d) => d[1].get("2019")) /
    d3.sum(neighborhoods, (d) => 1);

  const totalNeighborhoods = d3.sum(neighborhoods, (d) => 1);
  const chicago_ratio_avg = d3.median(neighborhoods, (d) => {
    const total = d[1].get("2021");
    const t = socioEconomic.filter(
      (o) => normalize(o.name) === normalize(d[0])
    )[0];
    if (t) {
      return (+total / +t.population) * 10000;
    }
  });
  return (
    <div className={styles.NeighborhoodTable}>
      <h3>Homicides By Neighborhood</h3>
      <table>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th className={styles.Explain} colspan="2">
              By {this_day} in previos years
              <br />
              (differnece compared to 2021)
            </th>
          </tr>
          <tr>
            <th>Neighborhood</th>
            <th>2021 Homicides</th>
            <th>per 10,000</th>
            <th>2020</th>
            <th>2019</th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.CityAverage}>
            <td>Chicago Avg.</td>
            <td>{chicago_avg.toFixed(1)}</td>
            <td>{chicago_ratio_avg.toFixed(1)}</td>
            <td>{chicago_2020_avg.toFixed(1)}</td>
            <td>{chicago_2019_avg.toFixed(1)}</td>
          </tr>
          {Array.from(neighborhoods)
            .sort(
              (a, b) =>
                neighborhoods.get(b[0]).get("2021") -
                neighborhoods.get(a[0]).get("2021")
            )
            .filter((d, i) => (fullMode ? true : i < 10))
            .map((d) => {
              const t = socioEconomic.filter(
                (o) => normalize(o.name) === normalize(d[0])
              )[0];
              const y2021 = neighborhoods.get(d[0]).get("2021");
              const y2020 = neighborhoods.get(d[0]).get("2020");
              const y2019 = neighborhoods.get(d[0]).get("2019");
              if (t) {
                return (
                  <tr key={d[0].split("/")[0]}>
                    <td>{d[0].split("/")[0]}</td>
                    <td>{y2021 || 0}</td>
                    <td>
                      {y2021 ? ((y2021 / +t.population) * 10000).toFixed(1) : 0}
                    </td>
                    <td>
                      {y2020} ({y2021 - y2020 > 0 ? "+" : null}
                      {y2021 - y2020 || 0})
                    </td>
                    <td>
                      {y2019} ({y2021 - y2019 > 0 ? "+" : null}
                      {y2021 - y2019 || 0})
                    </td>
                  </tr>
                );
              }
            })}
        </tbody>
      </table>
      <button onClick={() => setFullMode(!fullMode)}>
        {fullMode ? "Show Less" : "Show More"}
      </button>
      <p className={styles.Notes}>
        Sources: State and local health agencies. Population and demographic
        data from Census Bureau.
      </p>
    </div>
  );
};

export default NeighborhoodTable;
